<template>
    <div class="content-960 mobile-row" style="margin-top:40px;max-width: 470px; text-align: center;">
        <div class="wrapper-960 clearfix">
            <div class="titles">
                <h2 class="uppercase">
                    <b>Trocar escola</b><br />
                </h2>
            </div>
            <div class="row">
                <div class="col-12 col-sm-12 col-lg-12 col-sm-12">
                    <label class="title title--news mb-2 cna-login__title">Selecione sua escola</label>
                    <select class="form-control" v-model="escola_escolhida">
                        <option value="0">Selecione</option>
                        <option v-for="escola in escolas" v-bind:key="escola.escolaId" :value="escola.escolaId">{{ escola.nomeEscola }}</option>
                    </select>
                </div>
            </div>
            <br />
            <div class="row">
                <div class="col-12 col-sm-12 col-lg-12 col-sm-12">
                    <div class="form-group cna-login__group">
                        <button type="button" class="btn btn-sm btn-success p-2" v-bind:disabled="escola_escolhida == 0" @click="trocarEscola()">Escolher Escola</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import Auth from '@/common/auth'
    import Global from '@/common/global'
    import Cache from '@/common/cache'
    import { Api } from '@/common/api'

    export default {
        name: 'trocarescola',
        data() {
            return {
                escola_escolhida: 0,
                colaborador_id: 0,
                escolas: []
            }
        },
        methods: {
            trocarEscola() {
                Auth.claimsAddLoginSso("tenant", this.escola_escolhida.toString())
            }
        },
        mounted() {
            var user = Auth.currentUser();
            this.colaborador_id = user.sub;
            this.escolas = user.escolas;
        }
    }
</script>
